<script lang="ts" setup>
const props = defineProps<{ data: Category }>()
const col = GetCollection(props.data.collectionName, props.data) ?? {}
const { viewRoute, singular } = col
</script>

<template>
  <section
    class="bg-blue px-6 md:px-8 lg:px-10 relative shadow-lg rounded-3xl md:rounded-4xl flex justify-center  flex-col overflow-clip py-6 md:py-8 lg:py-10">

    <div class="flex flex-wrap gap-6 items-center">
      <div class="py-6 text-white flex-1">
        <HeadingText tag="h3" class="text-pink">
          {{ data.name }}
        </HeadingText>
        <section v-if="data?.description" v-html="data.description"
          class="htmldescription max-w-4xl max-h-12 overflow-hidden text-ellipsis text-white mt-3" />
      </div>
      <UButton v-if="viewRoute" :to="viewRoute" icon="ri:arrow-right-line" trailing size="xl" color="pink">
        View {{ singular }}
      </UButton>
    </div>
  </section>
</template>
